<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-11 16:07:18
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:24:25
 * @Description: file content
 小程序底部分享组件
 -->
<template>
  <div class="container">
    <div class="warp" v-if="!isShowShareGuide&&!isClickMoments" @click="clickOther">
      <div class="content" @click.stop>
        <div class="top">
          <div class="line"></div>
          <div class="title">分享该名片获客文章</div>
        </div>
        <div class="middle">
          <div class="middle_item" @click.stop="clickSaveImg">
            <div class="middle_icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/components/share/saveimg2.png" />
            </div>
            <span class="middle_text">存图分享</span>
          </div>

          <div class="middle_item" @click.stop="clickFriend">
            <div class="middle_icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/components/share/weixin2.png" />
            </div>
            <span class="middle_text">好友和群</span>
            <!-- <span class="middle_text2">小程序形式</span> -->
          </div>
          <div class="middle_item" @click.stop="clickMoments">
            <div class="middle_icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/components/share/pengyouquan2.png" />
            </div>
            <span class="middle_text">朋友圈</span>
            <!-- <span class="middle_text2">H5链接形式</span> -->
          </div>
        </div>
        <div class="bottom">
          不同的方式，抢不同的
          <span>惊喜</span>呦，快来都试试吧
        </div>
      </div>
    </div>

    <HdkShareGuide v-if="isShowShareGuide" v-on:close="clickOther"></HdkShareGuide>
    <ShareAfterAction v-if="isShowShareAfterAction" v-on:close="closeShareAfterAction"></ShareAfterAction>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="closeShowImg2"></ShowImg2>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import createimg from "@/utils/createimg";
const HdkShareGuide = () => import("@/components/hdk-share_guide.vue");
const ShareAfterAction = () => import("@/components/share-after-action");
const ShowImg2 = () => import("@/components/showimg2.vue");

export default {
  components: {
    HdkShareGuide,
    ShareAfterAction,
    ShowImg2
  },
  props: {},
  data() {
    return {
      isShowShareGuide: false,
      isClickMoments: false,
      isShowShareAfterAction: false,
      imgUrlCardPoster: "",
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    clickSaveImg() {
      let that = this;
      if (that.imgUrlCardPoster) {
        this.showImg2 = {
          url: this.imgUrlCardPoster,
          width: "80%",
          intro: "亲，请长按保存！",
          isShow: true
        };
      } else {
        that.$setLoading(true);
        util.checkMapStateCallback(that, ["cardInfo"]).then(() => {
          createimg.getPoster(that).then(imgUrl => {
            that.$setLoading(false);
            that.imgUrlCardPoster = imgUrl;
            that.showImg2 = {
              url: that.imgUrlCardPoster,
              width: "80%",
              intro: "亲，请长按保存！",
              isShow: true
            };
          });
        });
      }
    },
    closeShowImg2() {
      this.showImg2.isShow = false;
      this.$emit("close");
    },
    // 点击微信好友
    clickFriend: function() {
      this.isShowShareGuide = true;
      // 触发一次分享回调
      setTimeout(() => {
        if (
          this.hdkUserInfo &&
          this.hdkUserInfo.User &&
          this.cardInfo &&
          this.cardInfo.User &&
          this.hdkUserInfo.User.Id == this.cardInfo.User.Id
        ) {
          //不展示分享后页面
        } else {
          this.isShowShareAfterAction = true;
        }
      }, 2000);
      this.setShare();
    },
    // 点击朋友圈，走分享到朋友圈流程
    clickMoments: function() {
      this.isClickMoments = true;
      setTimeout(() => {
        if (
          this.hdkUserInfo &&
          this.hdkUserInfo.User &&
          this.cardInfo &&
          this.cardInfo.User &&
          this.hdkUserInfo.User.Id == this.cardInfo.User.Id
        ) {
          //不展示分享后页面
          //原来的销毁组件是在分享后页面，现在自己的页面不展示分享后页面的话，主动销毁下组件，防止再次点击不能触发。
          this.$emit("close");
        } else {
          this.isShowShareAfterAction = true;
        }
      }, 2000);
      this.setShare();
      util.navigateToShareMomentsCurrentPageNoFollowReturnQrCode(this);
    },
    clickOther: function() {
      this.isShowShareGuide = false;
      this.$emit("close");
    },
    setShare() {
      comreq.actShare(this);
    },
    closeShareAfterAction() {
      this.isShowShareAfterAction = false;
      this.$emit("close");
    }
  },
  created() {
    let that = this;
    util.checkMapStateCallback(that, ["cardInfo"]).then(() => {
      createimg.getPoster(that).then(imgUrl => {
        that.imgUrlCardPoster = imgUrl;
      });
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.warp {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 30;
}
.content {
  position: fixed;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #fff;
}

.top {
  height: 1.5rem;
  position: relative;
}
.top .line {
  position: absolute;
  top: 0.75rem;
  height: 1px;
  width: 80%;
  left: 10%;
  background-color: #eaeaea;
  z-index: -1;
}
.top .title {
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  color: #999999;
  font-size: 13px;
  background-color: #fff;
  width: 128px;
  margin: 0 auto;
}
/* 底部导航 */
.middle {
  width: 100%;
  height: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.8rem;
}

.middle_item {
  flex: 1;
  text-align: center;
  position: relative;
  height: 1.6rem;
}

.middle_icon {
  padding-top: 0.2rem;
  width: 100%;
}

.middle_icon > img {
  width: 1.2rem;
  height: 1.2rem;
}

.middle_text {
  padding-top: 0.1rem;
  display: block;
  color: #333333;
  font-size: 13px;
}
.middle_text2 {
  padding-top: 0.1rem;
  display: block;
  color: #333333;
  font-size: 9px;
}
.bottom {
  text-align: center;
  color: #666666;
  margin-bottom: 0.8rem;
  font-size: 13px;
}
.bottom span {
  color: #f68d8f;
}
</style>